<template>
    <div class="BaseForm">
        <h3 v-if="heading">{{ heading }}</h3>
        <BaseText
            class="mb-spacer"
            v-if="!submitted"
            :text="text"
        />

        <BaseText
            v-else
            :text="confirmation"
        />

        <form
            v-on:submit.prevent="submit"
            v-if="!submitted"
        >
            <BaseInput
                v-for="(field, index) in fields"
                :key="index"
                :field="field"
                :error="showError(field)"
                v-model="formData[field.name]"
            />

            <InputCheckbox
                v-model="terms"
                name="terms"
                :terms-msg="termsMsg"
            />

            <p
                class="error"
                v-if="!terms && $v.terms.$error"
            >
                You must accept the terms
            </p>

            <BaseButton
                tag="button"
                class="mt-small"
                :class="{ 'is-loading' : loading}"
            >
                <span>Submit</span>
                <figure
                    class="ellipsis"
                    v-if="loading"
                >
                    <div v-for="index in 4" :key="index"></div>
                </figure>
            </BaseButton>

            <p
                class="error mt-medium"
                v-if="failed"
            >
                There has been an error sending your form. Please, try again.
            </p>
        </form>
    </div>
</template>

<script>
let validators = {}

import axios from 'axios';
import { stringify } from 'qs';
import { validationMixin } from 'vuelidate';
import { required } from "vuelidate/lib/validators";

const mustBeTrue = (value) => value === true

export default {
    name: 'BaseForm',
    mixins: [validationMixin],
    data() {
        return {
            submitted: false,
            terms: false,
            loading: false,
            formData: {},
            failed: false,
        }
    },
    props: {
        fields: {
            type: Array,
            required: true
        },
        heading: {
            type: String
        },
        text: {
            type: String
        },
        list: {
            type: String
        },
        confirmation: {
            type: String
        },
        id: {
            type: Number,
            required: true
        },
        termsMsg: {
            type: String,
            default: ''
        },
    },
    validations: {
        formData: validators,
        terms: {
            mustBeTrue
        }
    },
    methods: {
        showError(field) {
            if (field.required) {
                return this.$v.formData[field.name].$error
            } else {
                return false
            }
        },
        submit () {
            const campaingMonitorData = {
                action: 'e7newsletter/default/subscribe',
                email: this.formData.email || this.formData.Email,
                platform: 'campaign-monitor',
                list: this.list,
                [window.csrfTokenName]: window.csrfTokenValue,
            };

            this.formData['action'] = 'wheelform/message/send'
            this.formData['form_id'] = this.id
            this.formData[[window.csrfTokenName]] = window.csrfTokenValue

            this.$v.$touch()

            if (!this.$v.formData.$error && !this.$v.terms.$error) {

                this.loading = true

                axios.post('/', stringify(campaingMonitorData))
                    .then(() => {
                        axios.post('wheelform/message/send', stringify(this.formData))
                            .then(() => {

                            })
                            .catch((error) => {
                                console.log(error.response)
                            });

                        setTimeout(() => {
                            this.loading = false
                            this.$scrollTo('.scrollTarget', 500, { offset: -200 })
                            this.submitted = true
                        }, 1000);
                    })
                    .catch(() => {
                        this.failed = true
                    });
            }
        }
    },
    created() {
        this.fields.map((field) => {
            this.formData[field.name] = '';
        })

        this.fields.filter((field) => field.required).map((field) => {
            validators[field.name] = { required }
        })

        const savedEmail = localStorage.getItem('emailAddress');
        if (savedEmail) {
            this.formData.email = savedEmail
        }
    }
}
</script>
<style lang="scss" scoped>

    h3 {
        font-size: 1.2rem;
        line-height: 1.2;
        color: $action-color;
        margin-bottom: 1rem;

        @include media-query(desk) {
            font-size: 1.3rem;
            line-height: 1.285714285714286;
        }
    }

    .error {
        position: relative;
        top: -20px;
        color: $error-color;
        font-size: 0.65rem;
        font-weight: 600;
    }

    .BaseButton {
        position: relative;

        &.is-loading {
            background: getColor('blue', 'charcoal');
            pointer-events: none;

            span {
                opacity: 0;
            }
        }

        .ellipsis {
            position: absolute;
            width: 60px;
            height: 100%;
            left: calc(50% - 30px);
            top: 0;

            div {
                position: absolute;
                top: 27px;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: rgba(getColor('white'), 0.5);
                animation-timing-function: cubic-bezier(0, 1, 1, 0);

                &:nth-child(1) {
                    left: 6px;
                    animation: ellipsis1 0.6s infinite;
                }
                &:nth-child(2) {
                    left: 6px;
                    animation: ellipsis2 0.6s infinite;
                }
                &:nth-child(3) {
                    left: 26px;
                    animation: ellipsis2 0.6s infinite;
                }
                &:nth-child(4) {
                    left: 45px;
                    animation: ellipsis3 0.6s infinite;
                }
            }
        }
    }


    @keyframes ellipsis1 {
        0% {
            transform: scale(0);
        }
        100% {
            transform: scale(1);
        }
    }

    @keyframes ellipsis3 {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(0);
        }
    }

    @keyframes ellipsis2 {
        0% {
            transform: translate(0, 0);
        }
        100% {
            transform: translate(19px, 0);
        }
    }

</style>
